<div data-target="setPassword" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>
      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'PAGE_HEADING' | translate }}
        </h1>
        <p class="dt-l-article__section__description" [innerHtml]="pageSubheading"></p>
        <form [formGroup]="newPasswordForm" (ngSubmit)="savePassword()">
          <div *ngFor="let field of newPasswordScreen.fields.results">
            <dt-dynamic-form-field
              [formData]="field"
              [fieldFormGroup]="newPasswordForm.get(field.id)"></dt-dynamic-form-field>
          </div>
          <!-- <div
            class="text-small color-danger"
            *ngIf="newPasswordForm.get(newPasswordScreen.id)['controls'].confirmPassword.errors?.matchPassword"
          > -->
          <!-- <div class="text-small color-danger" *ngIf="this.newPasswordForm.get('confirmPassword').errors?.matchPassword">
            {{'CONFIRM_PASSWORD_ERROR' | translate}}
          </div> -->

          <div class="dt-l-button-group__vertical">
            <button type="submit" class="dt-c-button block primary" [disabled]="newPasswordForm.invalid">
              {{ 'SAVE_PASSWORD' | translate }}
            </button>
            <button type="button" (click)="cancelSetPassword()" class="dt-c-button block transparent text-small">
              {{ 'CANCEL' | translate }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </article>
</div>
